import { render, staticRenderFns } from "./ListClients.vue?vue&type=template&id=635fc1ac&"
import script from "./ListClients.vue?vue&type=script&lang=js&"
export * from "./ListClients.vue?vue&type=script&lang=js&"
import style0 from "./ListClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports